module.exports = __webpack_public_path__ + "img/Coming-soon-Landing-Page.4b62314f.png";